import { Modal } from 'react-bootstrap'
import { KTSVG } from '_metronic/helpers'
import { SimpleModalProps } from 'Types/Presentation/Components/Modal/SimpleModal'

const SimpleModal: React.FC<SimpleModalProps> = ({
	id,
	show,
	size,
	handleClose,
	title,
	customHeader,
	handleConfirm,
	onEntered,
	centered,
	children,
	customFooter,
	confirmButtonText,
	cancelButtonText,
}) => {
	return (
		<>
			<Modal
				id={id}
				tabIndex={-1}
				aria-hidden="true"
				dialogClassName={`modal-dialog modal-dialog-centered modal-${size} ${
					centered ? 'modal-dialog-centered' : ''
				}`}
				show={show}
				onHide={handleClose}
				onEntered={onEntered}>
				{/* begin:: Modal Header */}
				{(title || customHeader) && (
					<div className="modal-header">
						{customHeader ? (
							customHeader
						) : (
							<>
								<h5 className="modal-title">{title}</h5>
								<div
									className="btn btn-icon btn-sm btn-active-light-primary ms-2"
									data-bs-dismiss="modal"
									aria-label="Close">
									<KTSVG
										path="/media/icons/duotune/arrows/arr061.svg"
										className="svg-icon svg-icon-2x"
									/>
								</div>
							</>
						)}
					</div>
				)}
				{/* end:: Modal Header */}

				{/* begin:: Modal Body */}
				<div className="modal-body py-lg-10 px-lg-10">{children}</div>
				{/* end:: Modal Body */}

				{/* begin:: Modal Footer */}
				<div className="modal-footer">
					{customFooter ? (
						customFooter
					) : (
						<>
							<button
								type="button"
								className="btn btn-light"
								data-bs-dismiss={id}
								onClick={handleClose}>
								{cancelButtonText ?? 'Close'}
							</button>
							<button type="button" className="btn btn-primary" onClick={handleConfirm}>
								{confirmButtonText ?? 'Save changes'}
							</button>
						</>
					)}
				</div>
				{/* end:: Modal Footer */}
			</Modal>
		</>
	)
}

export default SimpleModal
